module.exports = __webpack_public_path__ + "images/Send.2fbea0406efb27a19df74cea25549bea.svg";